import { UMButton, UMStack, UMToolGroup, UMR } from '../_components';
import { CalcButton } from './CalcButton';
import type { useNetwork } from './useNetwork';

export function NetworkControls({ network: n, blocked }: {
  network: ReturnType<typeof useNetwork>; blocked: boolean;
}) {
  const disabled = blocked || n.loading || !!n.activeTool;
  return <UMStack gap={12}>
    <UMStack>
      <CalcButton disabled={disabled || !!n.precondition} onClick={n.calculate}>Calculer tracé optimal</CalcButton>
      <div role="status" aria-live="polite" style={{ fontSize: 12, color: UMR.textMuted }}>
        {n.traceLoading && <div>Calcul simulé en cours…</div>}
        {n.precondition && <div>{n.precondition}</div>}
        {!n.traceLoading && n.trace && <div>{n.trace}</div>}
        {n.message && n.message !== n.precondition && <div>{n.message}</div>}
        {n.stale && <div role="alert" style={{ fontWeight: 700 }}>
          Raccordements obsolètes — les centrales, bâtiments ou canalisations ont changé.
          Les anciens liens simulés sont atténués et ne sont plus conformes.
          Relancez manuellement le calcul. Les canalisations manuelles sont conservées.
        </div>}
      </div>
      {n.traceLoading && <UMButton variant="secondary" onClick={n.cancel}>Annuler le calcul</UMButton>}
    </UMStack>
    <UMToolGroup activeId={n.activeTool}
      tools={[
        { id: 'draw-pipe', icon: 'polyline', label: 'Tracer manuel', disabled: disabled && n.activeTool !== 'draw-pipe' },
        { id: 'erase-pipe-lasso', icon: 'ink_eraser', label: 'Effacer',
          disabled: (disabled && n.activeTool !== 'erase-pipe-lasso') || !n.network.pipes.length },
      ]}
      onSelect={(id) => { if (id === 'draw-pipe' || id === 'erase-pipe-lasso') n.start(id); }} />
  </UMStack>;
}
